module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQtJREFUWEftl8FtAjEQRf9vIbdEoYUdl8CVEpICKCFFpAQKSErgSgmebQEUbmnhR5aIBItRMLuSUWSfxzPP35bnD1F5sXJ9ZAHc/RnAu6Q5gMeRkHuSGwBvZrYb5joDOBR3SQ8jC59sJ/kNwIYQOYAPSS8k1wCWOeoSsMOBVpIWJD/N7PV4/xlAjPEryU5yNrb4b6EEIWkLYB9CePoLQCkghDDpA40xZvPmFGgATYGmQFOgKdAUuA8FSnp+Seywy17shiVJS2KvBrh7P9D3/ULSKp2e5LLrumThLq7JDYm7byUl95wAdmY2+zcAV5nSkisoMqXuXteWVx9M0kOqOpqVfCpTxE46fNwC9AMoBxowftUF+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_phone.png
// module id = e4gF
// module chunks = 2